import { REG_EXP } from 'constants/index';

const NO_VALIDATION_FIELDS = ['template_search'];

export function showFormErrors(that, inputs) {
  let isFormValid = true;
  for (var i = 0; i < inputs.length; i++) {
    var input = inputs[i];
    input.classList.add('active');
    if (!NO_VALIDATION_FIELDS.includes(input.name)) {
      const isInputValid = showInputError(that, input.name);
      if (!isInputValid) {
        isFormValid = false;
      }
    }
  }

  return isFormValid;
}

export function showInputError(that, refName) {
  const validity = that.refs[refName].validity;
  const label = document.getElementById(`${refName}Label`).textContent;
  const error = document.getElementById(`${refName}Error`);
  // const isWebsite = refName === "website";
  const isZip = refName === 'zip' || refName === 'l_zip';
  const islocationCodeError = refName === 'location_code';

  if (!validity.valid) {
    if (isZip && validity.valueMissing) {
      error.textContent = `${label} code is required`;
    } else if (islocationCodeError) {
      error.textContent = `${label} code must be of 4 to 6 number`;
    } else if (validity.valueMissing) {
      error.textContent = `${label} is required`;
    } else if (isZip && validity.patternMismatch) {
      error.textContent = `${label} code is invalid`;
    } else if (isZip && validity.customError) {
      error.textContent = `${label} is invalid`;
    } else if (validity.typeMismatch || validity.patternMismatch) {
      error.textContent = `${label} is in wrong format`;
    }
    return false;
  }

  if (error) error.textContent = '';
  return true;
}

export function validate(name, value) {
  if (!value) {
    return 'This field is required';
  } else if (name == 'email') {
    if (!REG_EXP.EMAIL.test(value)) return 'Email is invalid';
  } else if (name == 'zip') {
    if (!REG_EXP.ZIP.test(value)) return 'Zip is invalid';
  }
  return false;
}

export const validateForm = formValues => {
  const formFields = Object.keys(formValues);
  const _state = {};
  let valid = true;
  formFields.map(fieldName => {
    const fieldData = formValues[fieldName];
    const error = validate(fieldName, fieldData.value);
    valid = !error && valid;
    _state[fieldName] = { ...fieldData, error };
  });
  return { valid, _state };
};

export const checkValidity = ({ name, value, type, required }) => {
  if (Array.isArray(value)) {
    if (required) {
    }
  }
  if (required && !value.trim()) return true;
  if (type == 'email') {
    const result = REG_EXP.EMAIL.test(value);
    return !result;
  } else if (type == 'tel') {
    const result = REG_EXP.PHONE.test(value);
    return !result;
  } else if (name == 'zip' || type == 'zip') {
    const result = REG_EXP.ZIP.test(value);
    return !result;
  } else if (type == 'url') {
    const result = REG_EXP.WEBSITE.test(value);
    return !result;
  }

  return false;
};

export const handleFormValidate = form => {
  const inputFields = form.getElementsByTagName('input');
  const textArea = form.getElementsByTagName('textarea');
  const formFields = [...inputFields, ...textArea];
  const formValues = {};
  let hasErrors = false;

  for (let i = 0; i < formFields.length; i++) {
    const { name, type, required, value } = formFields[i];
    const fieldHasError =
      checkValidity({ name, type, required, value }) && (required || value);
    formValues[name] = {
      value,
      hasError: fieldHasError,
    };
    hasErrors = hasErrors || fieldHasError;
  }

  return { hasErrors, formValues };
};



// WEBPACK FOOTER //
// ./src/utils/formvalidate.js